export default function Footer() {
  // const instagramUrl =
  //   "https://www.instagram.com/sreesunrisemakeup?igsh=MTkxcXpoZml2bW80cw==";

  const whatsappUrl =
    "https://wa.me/+916304824076?text=Hi!%20I%20would%20like%20to%20know%20more%20about%20your%20services.";

  const links = [
    {
      href: "https://vaayudigitals.netlify.app/",
      label: "Vaayu DigitalAi",
    },
  ];

  const quickLinks = [
    { href: "#home", label: "Home" },
    { href: "#about", label: "About" },
    { href: "#gallery", label: "Gallery" },
    { href: "#contact", label: "Contact" },
  ];

  return (
    <footer className="relative mt-10 overflow-hidden border-t border-white/10 bg-dusk-900 mb-20">
      {/* Decorative Glow */}
      <div className="pointer-events-none absolute -left-40 -top-40 h-96 w-96 rounded-full bg-sunrise-500/10 blur-3xl" />

      <div className="pointer-events-none absolute -bottom-40 -right-40 h-96 w-96 rounded-full bg-blush-500/10 blur-3xl" />

      <div className="section relative">
        {/* Main Footer */}
        <div className="grid gap-12 py-14 sm:py-16 md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr]">
          {/* Brand */}
          <div>
            <a href="#home" className="group inline-block">
              <h2 className="font-display text-3xl font-bold text-white transition group-hover:text-sunrise-400">
                Sree Sunrise
              </h2>

              <p className="mt-1 text-xs font-medium uppercase tracking-[0.35em] text-blush-400">
                Makeup Studio & Store
              </p>
            </a>

          <p className="mt-6 max-w-sm mx-auto text-center text-sm leading-7 text-white/50 md:mx-0 md:text-left">
  Enhancing your natural beauty with elegant, personalized and
  timeless makeup looks for every special occasion.
</p>
          </div>

         {/* Quick Links */}
<div className="text-center md:text-left">
  <h3 className="font-display text-lg font-semibold text-white">
    Quick Links
  </h3>

  <div className="mt-5 space-y-3">
    {quickLinks.map((link) => (
      <a
        key={link.label}
        href={link.href}
        className="group flex w-full items-center justify-center gap-2 text-sm text-white/50 transition hover:text-white md:justify-start"
      >
        <span className="h-px w-0 bg-sunrise-400 transition-all duration-300 group-hover:w-4" />

        <span>{link.label}</span>
      </a>
    ))}
  </div>
</div>

          {/* Contact / CTA */}
          <div>
            <h3 className="font-display text-lg font-semibold text-white">
              Let's Connect
            </h3>

            <p className="mt-5 text-sm leading-6 text-white/50">
              Have a special occasion coming up? We'd love to create your
              perfect look.
            </p>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-sunrise-600 to-blush-500 px-5 py-3 text-sm font-semibold text-white shadow-glow transition duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              <span>💬</span>
              Chat on WhatsApp
              <span className="transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </a>
          </div>
        </div>

        {/* Decorative Line */}
        {/* sunrise-logo */}
        <div className="relative h-px bg-gradient-to-r from-transparent via-white/10 to-transparent">
          {/* <div className="absolute left-1/2 top-1/2 h-1 w-1 -translate-x-1/2 -translate-y-1/2 rounded-full bg-sunrise-400 shadow-glow" /> */}
          <img
            src="/sun-logo.png"
            alt="Sree Sunrise Logo"
            className="absolute left-1/2 top-1/2 h-12 w-18 -translate-x-1/2 -translate-y-1/2"
          />
        </div>

        {/* Bottom Footer */}
        <div className="flex flex-col items-center justify-between gap-4 py-6 text-center md:flex-row md:text-left">
          {/* Copyright */}
          <p className="text-xs leading-6 text-white/40">
            © {new Date().getFullYear()}{" "}
            <span className="text-white/60">Sree Sunrise Makeup Studio</span>.
            All rights reserved.
          </p>

          {/* Developer */}
          <p className="text-xs text-white/40">
            Hosted & Developed by{" "}
            <a
              href={links[0].href}
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-sunrise-400 transition hover:text-sunrise-300 hover:underline hover:underline-offset-4"
            >
              {links[0].label}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
